var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconZip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3568 5L20.6902 8.33333H35.0002C35.4422 8.33333 35.8661 8.50893 36.1787 8.82149C36.4912 9.13405 36.6668 9.55797 36.6668 10V33.3333C36.6668 33.7754 36.4912 34.1993 36.1787 34.5118C35.8661 34.8244 35.4422 35 35.0002 35H5.00016C4.55814 35 4.13421 34.8244 3.82165 34.5118C3.50909 34.1993 3.3335 33.7754 3.3335 33.3333L3.3335 6.66667C3.3335 6.22464 3.50909 5.80072 3.82165 5.48816C4.13421 5.17559 4.55814 5 5.00016 5H17.3568ZM30.0002 30H23.3335V25H26.6668V21.6667H23.3335V18.3333H26.6668V15H23.3335V11.6667H19.3102L15.9768 8.33333H6.66683L6.66683 31.6667H33.3335V11.6667H26.6668V15H30.0002V18.3333H26.6668V21.6667H30.0002V30Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZip);
export default __webpack_public_path__ + "static/media/IconZip.e353cf7c.svg";
export { ForwardRef as ReactComponent };